import { ArrowRight, Star } from "lucide-react";

export const ProductsIntro = () => {
  const scrollToProducts = () => {
    document
      .getElementById("produse")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="products-intro"
      className="relative overflow-hidden border-b border-sky-100/60"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-cyan-200/40 blur-3xl" />
        <div className="absolute top-10 right-0 w-96 h-96 rounded-full bg-teal-200/30 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-10 pt-4 md:pt-10 pb-2 md:pb-8">
        <div className="grid md:grid-cols-2 gap-3 md:gap-10 items-center">
          {/* Logo on the left */}
          <div className="relative flex justify-center md:justify-start order-1">
            <div className="relative w-full max-w-[260px] sm:max-w-xs md:max-w-md">
              {/* Soft glow behind logo to make it pop on light bg */}
              <div className="absolute inset-0 -m-4 rounded-[3rem] bg-gradient-to-br from-cyan-100/60 via-white/40 to-emerald-100/60 blur-2xl" />
              <img
                src="/assets/logo-detecogreen.jpg"
                alt="Detereco-Green — Curățenie inteligentă, viață mai ușoară"
                width="1254"
                height="1254"
                className="relative w-full h-auto rounded-2xl drop-shadow-[0_8px_24px_rgba(8,145,178,0.18)] select-none"
                draggable="false"
              />
            </div>
          </div>

          {/* Text content on the right */}
          <div className="order-2 max-w-xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-cyan-100 mb-3">
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-3 h-3 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <span className="text-[11px] font-semibold tracking-wider uppercase text-slate-700">
                Peste 3000 clienți mulțumiți
              </span>
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 leading-[1.05]">
              Detergenți premium,
              <span className="block text-cyan-600">livrați direct acasă.</span>
            </h1>
            <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed">
              6 produse profesionale fabricate în România. Comandă într-un minut
              pe WhatsApp, plătești cash la curier.
            </p>
            <button
              onClick={scrollToProducts}
              data-testid="intro-cta-scroll"
              className="mt-5 inline-flex group h-12 px-6 rounded-full bg-slate-900 hover:bg-cyan-600 text-white font-semibold items-center gap-2 transition-colors"
            >
              Vezi toate produsele
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
